import Web3 from 'web3';

let web3;
if (Web3.givenProvider) {
  web3 = new Web3(Web3.givenProvider);
}

export default {
  data() {
    return {
      notInstalled: false,
      locked: false,
      accountInterval: null,
      wrongNetwork: true,
    };
  },
  mounted() {
    this.accountInterval = setInterval(this.checkMetaMask, 100);
    // this.checkMetaMask();
  },
  destroyed() {
    clearInterval(this.accountInterval);
  },
  methods: {
    checkNetwork() {
      if (!web3) return;
      // @TODO: Open issue: https://github.com/MetaMask/metamask-extension/issues/4126
      // web3.version.getNetwork((err, netId) => {
      if (!web3.currentProvider.publicConfigStore) return;

      switch (web3.currentProvider.publicConfigStore._state.networkVersion) {
        // case '1':
        //   console.log('This is mainnet')
        //   break
        case '4':
          this.wrongNetwork = false;
          break;
        default:
          this.wrongNetwork = true;
      }
      // });
    },
    async checkMetaMask() {
      this.checkNetwork();

      if (typeof web3 === 'undefined') {
        this.notInstalled = true;
        this.$store.state.metaMaskStatus = false;
        return;
      }

      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      if (!account) {
        this.locked = true;
        this.$store.state.metaMaskStatus = false;
        return;
      }

      this.locked = false;
      this.$store.state.metaMaskStatus = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/metamaskWatcher.js